import {atom} from 'jotai'
import {ListFilter, StoreContactTitle, StoreList} from '../domain'

const list: StoreList = {
  dataList: [],
  paging: {
    currentPageNumber: 1,
    totalPagesNumber: 0,
    pageSize: 10,
    totalCount: 0,
  },
}

export const listAtom = atom<StoreList>(list)
export const listFilterAtom = atom<ListFilter>({
  filterList: [],
  orderList: [{type: 2, key: 'CreatedOn'}],
  paging: {
    currentPageNumber: 1,
    pageSize: 10,
  },
  search: {
    value: '',
    keyList: [],
  },
})

export const storeContactTitleListAtom = atom<StoreContactTitle[]>([])
